import React, { useState } from 'react';
import { Button, Form, Input, Modal, message } from 'antd';
import { IoMdAdd } from 'react-icons/io';
import { useCaseStudy } from '../../hooks/useCaseStudy';

const AddNewCase = () => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  const { useAddCaseStudy } = useCaseStudy();
  const addCaseMutation = useAddCaseStudy();

  const handleSubmit = async values => {
    try {
      await addCaseMutation.mutateAsync({
        title: values.title,
        content: values.Content,
      });
      message.success('Case added successfully!');
      form.resetFields();
      setOpen(false);
    } catch (error) {
      message.error('Failed to add case');
    }
  };

  return (
    <>
      <Button icon={<IoMdAdd />} type="primary" onClick={() => setOpen(true)}>
        Add New Case
      </Button>
      <Modal
        open={open}
        title="Add Case"
        onCancel={() => setOpen(false)}
        onOk={() => form.submit()}
        okText="Submit"
        confirmLoading={addCaseMutation.isLoading}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          name="add_case_form"
          onFinish={handleSubmit}
          preserve={false}
        >
          <Form.Item
            name="title"
            label="Case-Title"
            rules={[{ required: true, message: 'Please enter the Case Title' }]}
          >
            <Input placeholder="Please enter the Case Title" />
          </Form.Item>
          <Form.Item
            name="Content"
            label="Content"
            rules={[
              { required: true, message: 'Please enter the Case Content' },
            ]}
          >
            <Input placeholder="Please enter the Case Description" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddNewCase;
